import toastr from 'toastr';

export function maskSecret(str, length = 5) {
  return `${str.substring(0, length)}...${str.substring(str.length - length)}`;
}

export function displayApiValidationErrors(errors) {
  let objectProps = Object.keys(errors);
  if (objectProps.length > 0) {
    objectProps.map((prop) => {
      toastr.warning(errors[prop][0]);
    });
  }
}

export function shuffle8() {
  var shuffle = (a, b) => (Math.random() > 0.5 ? -1 : 1),
    lowercase = 'abcdefghijklmnopqrstuvwxyz'.split('').sort(shuffle).join('').substring(0, 4),
    uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('').sort(shuffle).join('').substring(0, 2),
    numeric = '0123456789'.split('').sort(shuffle).join('').substring(0, 2);

  return (lowercase + uppercase + numeric).split('').sort(shuffle).join('');
}

export function findPos(obj) {
  var curtop = 0;
  if (obj.offsetParent) {
    do {
      curtop += obj.offsetTop;
    } while ((obj = obj.offsetParent));
    return [curtop];
  }
}

export function paramsAreDifferent(a, b) {
  return JSON.stringify(a ?? {}) !== JSON.stringify(b ?? {});
}

export function setParamOnUrl(param, value) {
  var url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  if (params.has(param)) {
    params.set(param, value);
  } else {
    params.append(param, value);
  }
  window.history.replaceState({}, '', `${location.pathname}?${params}`);
}

export const updateObjectsInArray = (items, itemId, objPropName, newObjProps) => {
  return items.map((u) => {
    if (u[objPropName] === itemId) {
      return {
        ...u,
        ...newObjProps,
      };
    }
    return u;
  });
};
